import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { ISPJBPResponse } from './models/ISPJBPResponse'

export const requestJBPComposedReport = async <T>(
  filters: string,
  cancelObject?: HttpCancel
): Promise<ISPJBPResponse<T>> => {
  let response

  const url = proxy('/webservice/621/sp/v3/spJBPComposedReport/call')
  const payload = {
    'p.Filters': filters,
  }

  const [accessToken] = getTokens()

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    response = await Rest.post({ url, payload, cancelObject, headers })
  } catch (e: any) {
    const errorMessage = 'Failed to request Composed Report.'
    Logger.error(errorMessage)
    response = {
      Message: e.message || errorMessage,
      Rows: [],
      Total: 0,
    }
  }

  return response
}
